import {
  encartEditoMock,
  pushEncartsVertsMock,
  titreTexteMediaFranchiseCuisinistes1,
  titreTexteMediaFranchiseCuisinistes2,
  titreTexteMediaFranchiseCuisinistes3,
} from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  titreTexteMediaFranchiseCuisinistes1(),
  titreTexteMediaFranchiseCuisinistes2(),
  titreTexteMediaFranchiseCuisinistes3(),
  encartEditoMock,
  pushEncartsVertsMock,
];

export const franchiseCuisinistesMock: SlugPage = {
  ...pageBase({
    title: 'Espace Franchise - Cuisinistes pas comme les autres',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-b2b-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
